import React, { useState } from 'react';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import AllocationGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetAllocation/AllocationGrid';
import { searchFn } from './utils';
import BudgetSearch from './stores';

const InActivePortfolios = ({ data }: { data: any }) => {
  const [showInactive, setShowInactive] = useState(false);
  const { searchText } = BudgetSearch();

  return (
    <div>
      <div
        role="button"
        style={{
          fontSize: 16,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        }}
        onClick={() => setShowInactive(!showInactive)}
      >
        Inactive Portfolios{' '}
        {showInactive ? (
          <KeyboardArrowUpRoundedIcon style={{ fontSize: 16 }} />
        ) : (
            <ExpandMoreRoundedIcon style={{ fontSize: 16 }} />
          )}
      </div>
      {showInactive ? (
        <div className="section_body">
          <AllocationGrid
            data={searchFn(searchText, data)}
            entityTableHeaderProps={{
              title: ''
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default InActivePortfolios;
